import { render, staticRenderFns } from "./TopSku.vue?vue&type=template&id=2e28b319&scoped=true"
import script from "./TopSku.vue?vue&type=script&lang=js"
export * from "./TopSku.vue?vue&type=script&lang=js"
import style0 from "./TopSku.vue?vue&type=style&index=0&id=2e28b319&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e28b319",
  null
  
)

export default component.exports